/**
 * App 도메인 Query Hook Wrapper
 */

import {useQuery} from '@tanstack/react-query';
import {APP_QUERY_KEY_MAP} from '../api/app/constant';
import {appFactory} from '../factory/appFactory';

// ============================================
// useHelpsQuery
// ============================================

export function useHelpsQuery(...args: Parameters<typeof appFactory.helps>) {
  return useQuery(appFactory.helps(...args));
}

useHelpsQuery.getKey = (
  ...args: Parameters<typeof APP_QUERY_KEY_MAP.helps>
) => [...APP_QUERY_KEY_MAP.helps(...args)];

// ============================================
// useNoticesQuery
// ============================================

export function useNoticesQuery(
  ...args: Parameters<typeof appFactory.notices>
) {
  return useQuery(appFactory.notices(...args));
}

useNoticesQuery.getKey = (
  ...args: Parameters<typeof APP_QUERY_KEY_MAP.notices>
) => [...APP_QUERY_KEY_MAP.notices(...args)];

// ============================================
// useTastesServiceLangQuery
// ============================================

export function useTastesServiceLangQuery(
  ...args: Parameters<typeof appFactory.tastesServiceLang>
) {
  return useQuery(appFactory.tastesServiceLang(...args));
}

useTastesServiceLangQuery.getKey = (
  ...args: Parameters<typeof APP_QUERY_KEY_MAP.tastesServiceLang>
) => [...APP_QUERY_KEY_MAP.tastesServiceLang(...args)];
